import {
  getLoginTournamentConfig,
  getNoLoginTournamentConfig,
  tournamentStore,
} from "@/stores/tournamentStore";
import { userStore } from "@/stores/userStore";

// import { useConfigRestrict } from "./useConfigRestrict";

export const useTournament = () => {
  // const { tournamentCfg } = tournamentStore;
  // const { getStatusByDeny, getStatusByLabelsDeny } = useConfigRestrict();

  const initTournament = async () => {
    if (userStore.isLogin) {
      await getLoginTournamentConfig();
    } else {
      await getNoLoginTournamentConfig();
    }
  };

  const getCurrentActiveItems = () => {
    // const itemsBuTab = tournamentStore.tournamentItem
    //   .filter((item) => item.match_status === tournamentStore.tabActive)
    //   .filter((item) => {
    //     return (
    //       // 排除渠道
    //       getStatusByDeny(item.deny_pack, item.deny_pack_type, true) &&
    //       // 排除标签
    //       getStatusByLabelsDeny(item.deny_labels, item.deny_label_type)
    //     );
    //   });

    const itemsBuTab = tournamentStore.tournamentItem.filter(
      (item) =>
        item.match_status === tournamentStore.tabActive &&
        item.is_expired === 0,
    );

    return itemsBuTab;
  };

  return {
    // 初始化赛事配置
    initTournament,
    // 获取当前 Tab 对应的比赛列表
    getCurrentActiveItems,
  };
};
